import React from 'react';

import OrderDetails from 'components/sections/order-details';

const Track = props => (
  <OrderDetails isPublicTrack={true} {...props} />
);

export default Track;
